/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type EvalRunDeletedObject = {
  id: string;
  object: "eval.run.deleted";
  deleted: boolean;
};

/** @internal */
export const EvalRunDeletedObject$inboundSchema: z.ZodType<
  EvalRunDeletedObject,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  object: z.literal("eval.run.deleted"),
  deleted: z.boolean(),
});
/** @internal */
export type EvalRunDeletedObject$Outbound = {
  id: string;
  object: "eval.run.deleted";
  deleted: boolean;
};

/** @internal */
export const EvalRunDeletedObject$outboundSchema: z.ZodType<
  EvalRunDeletedObject$Outbound,
  z.ZodTypeDef,
  EvalRunDeletedObject
> = z.object({
  id: z.string(),
  object: z.literal("eval.run.deleted"),
  deleted: z.boolean(),
});

export function evalRunDeletedObjectToJSON(
  evalRunDeletedObject: EvalRunDeletedObject,
): string {
  return JSON.stringify(
    EvalRunDeletedObject$outboundSchema.parse(evalRunDeletedObject),
  );
}
export function evalRunDeletedObjectFromJSON(
  jsonString: string,
): SafeParseResult<EvalRunDeletedObject, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EvalRunDeletedObject$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EvalRunDeletedObject' from JSON`,
  );
}
